import { gql } from '@apollo/client';
import { PLATFORM_FIELDS } from 'src/graphql/entities/platform-user';

export const ADDRESS_FILE_FIELDS = gql`
  fragment AddressFileFields on AddressFile {
    id
    addressFileId
    partnerId
    addressId
    fileKey
    fileName
    contentType
    size
    uploadedBy
    pinnedAt
    createdAt
    updatedAt
  }
`;

export const ADDRESS_FILE_RELATIONS = gql`
  fragment AddressFileRelations on AddressFile {
    id
    uploadedByUser {
      ...PlatformUserFields
    }
  }
  ${PLATFORM_FIELDS}
`;
